module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/anchor_arrow-a8a2d63ef49e615c80669a035ac2b99b.svg";